import type { ILoginParams, ILoginResp } from '@/types/user.ts';
import { beLinkHttp } from './http';

/**
 * 登录
 */
export async function login(data: ILoginParams) {
	return beLinkHttp.post<ILoginResp>('/b-bff/pandora/auth/login', data);
}
